<template>
	<v-menu
		v-model="filterMenu"
		:close-on-content-click="false"
		:max-width="500"
		:min-width="400"
	>
		<template #activator="{ props: activatorProps }">
			<v-btn
				v-bind="activatorProps"
				icon="fal fa-filter"
				:color="filtersActive.length ? 'primary' : ''"
				:data-test="`${name}--filters__activation-btn`"
				size="x-small"
			>
			</v-btn>
		</template>
		<v-card :data-test="`${name}--filters`">
			<BaseCardTitle
				close-btn
				title="component.datatable.filterData"
				title-class="text-subtitle-1"
				@close="filterMenu = false"
			>
			</BaseCardTitle>
			<v-divider></v-divider>
			<v-list id="filterMenuList" lines="two">
				<slot name="filters" v-bind="{ filterValue, filterStore }">
					<template v-if="filters">
						<v-list-item
							v-for="(filter, index) in filters"
							:key="index"
							density="compact"
						>
							<template v-if="filter.icon" #prepend>
								<!-- <v-list-item-action class="pl-1 mr-2"> -->
								<v-icon
									v-if="filter.icon"
									:icon="filter.icon"
									size="small"
								></v-icon>
								<!-- </v-list-item-action> -->
							</template>

							<AC_Buildings
								v-if="filter.component === 'Buildings'"
								:disabled="!filterMenu"
								:icon="null"
								:multiple="false"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_Buildings>
							<AC_DocumentTypes
								v-if="filter.component === 'DocumentTypes'"
								:disabled="!filterMenu"
								:filled="false"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:model-value="filterValue(filter)"
								:placeholder="null"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							></AC_DocumentTypes>
							<AC_NoteTypes
								v-if="filter.component === 'NotesType'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_NoteTypes>
							<AC_Roles
								v-if="filter.component === 'Roles'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							></AC_Roles>
							<AC_Meter
								v-if="filter.component === 'MeterType'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_Meter>
							<AC_Users
								v-if="filter.component === 'Users'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:multiple="false"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_Users>
							<AC_PropertyManagers
								v-if="filter.component === 'PropertyManagers'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_PropertyManagers>
							<AC_Teams
								v-if="filter.component === 'Teams'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? t(filter.name) : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_Teams>
							<AC_CisTypes
								v-if="filter.component === 'CisType'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_CisTypes>
							<AC_TaskTypes
								v-if="filter.component === 'TaskType'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_TaskTypes>
							<AC_CraftsmanTaskProcesses
								v-if="filter.component === 'CraftsmanTaskProcess'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_CraftsmanTaskProcesses>
							<AC_CraftsmanTaskStatus
								v-if="filter.component === 'CraftsmanTaskStatus'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_CraftsmanTaskStatus>
							<AC_CraftsmanTaskTypes
								v-if="filter.component === 'CraftsmanTaskType'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_CraftsmanTaskTypes>
							<AC_Accounts
								v-if="filter.component === 'Accounts'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_Accounts>
							<AC_AccountingYears
								v-if="filter.component === 'AccountingYears'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_AccountingYears>
							<AC_ReportStatus
								v-if="filter.component === 'ReportStatus'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_ReportStatus>
							<AC_ReportTypes
								v-if="filter.component === 'ReportTypes'"
								:disabled="!filterMenu"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:placeholder="null"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								@update:model-value="filterStore(filter, $event)"
							>
							</AC_ReportTypes>
							<DatePicker
								v-if="
									['DatePicker', 'DatePickerFrom', 'DatePickerTo'].includes(
										filter.component
									)
								"
								:icon="null"
								:label="filter.name ? filter.name : undefined"
								:name="filter.component"
								:model-value="filterValue(filter)"
								style="width: 100%"
								:data-test-module="`${name}--filters`"
								:data-test="datePickerDataTest(filter.component)"
								@update:model-value="filterStore(filter, $event)"
							></DatePicker>
						</v-list-item>
					</template>
				</slot>
			</v-list>
		</v-card>
	</v-menu>
</template>

<script setup lang="ts">
import type { FilterDefinition } from '@/constants/filters'
import { useTableStateStore } from '@/stores/system/tableState.ts'
import AC_AccountingYears from 'components/templates/Autocomplete/AccountingYears.vue'
import AC_Accounts from 'components/templates/Autocomplete/Accounts.vue'
import AC_Buildings from 'components/templates/Autocomplete/Buildings.vue'
import AC_CisTypes from 'templates/Autocomplete/Cistypes.vue'
import AC_CraftsmanTaskProcesses from 'components/templates/Autocomplete/CraftsmanTaskProcess.vue'
import AC_CraftsmanTaskStatus from 'components/templates/Autocomplete/CraftsmanTaskStatus.vue'
import AC_CraftsmanTaskTypes from 'components/templates/Autocomplete/CraftsmanTaskType.vue'
import AC_DocumentTypes from 'components/templates/Autocomplete/Documenttypes.vue'
import AC_Meter from 'components/templates/Autocomplete/MeterType.vue'
import AC_NoteTypes from 'templates/Autocomplete/NoteTypes.vue'
import AC_PropertyManagers from 'components/templates/Autocomplete/PropertyManagers.vue'
import AC_ReportStatus from 'components/templates/Autocomplete/ReportStatus.vue'
import AC_ReportTypes from 'components/templates/Autocomplete/ReportTypes.vue'
import AC_Roles from 'components/templates/Autocomplete/Roles.vue'
import AC_TaskTypes from 'components/templates/Autocomplete/TaskType.vue'
import AC_Teams from 'components/templates/Autocomplete/Teams.vue'
import AC_Users from 'components/templates/Autocomplete/Users.vue'
import DatePicker from 'components/templates/DatePicker.vue'
import { computed, ref } from 'vue'
import BaseCardTitle from 'templates/Card/BaseCardTitle.vue'
import { useI18n } from 'vue-i18n'

type FilterProps = {
	name: string
	filters?: FilterDefinition[]
}

const { t } = useI18n()

const props = defineProps<FilterProps>()

const filterMenu = ref(false)

const { getFilterValue, addOrUpdateFilter, getFilters } = useTableStateStore()

const filtersActive = computed(() => getFilters(props.name))

function filterStore(filter: FilterDefinition, value: any) {
	addOrUpdateFilter(props.name, {
		value: value,
		definition: filter,
	})
}
function filterValue(data: FilterDefinition) {
	return getFilterValue(props.name, data)
}

// AAR-1713 — "Datum von" und "Datum bis" rendern sonst dasselbe data-test
// (…__datepicker-datepicker) und sind fuer Tests nicht auseinanderzuhalten: der
// DatePicker-Treiber nutzt das Label nur zur Validierung, nicht zur Auswahl.
// Der generische DatePicker behaelt bewusst seinen bisherigen Wert (undefined ->
// Fallback 'datepicker'), damit bestehende Selektoren gueltig bleiben.
// Die Werte duerfen die Zeichenfolge '__datepicker' NICHT enthalten: der
// Cypress-DatePicker-Treiber entfernt sie per blindem replace() aus dem Selektor
// (DatePicker.ts:85) und zerlegt sich damit seinen eigenen Selektor.
function datePickerDataTest(component: string): string | undefined {
	if (component === 'DatePickerFrom') return 'date-from'
	if (component === 'DatePickerTo') return 'date-to'
	return undefined
}
</script>

<style lang="scss" scoped>
#filterMenuList {
	.v-list-item:hover {
		background-color: inherit;
	}
}
</style>
